import React from 'react';

interface StatCardProps {
  value: string;
  label: string;
  icon?: string;
  gradientFrom?: string;
  gradientTo?: string;
}

const StatCard = ({ 
  value, 
  label, 
  icon, 
  gradientFrom = 'from-red-500', 
  gradientTo = 'to-red-700' 
}: StatCardProps) => {
  return (
    <div className="relative p-6 rounded-2xl bg-white border border-gray-200 text-center space-y-3">
      {icon && (
        <div className={`relative w-12 h-12 mx-auto rounded-full bg-gradient-to-br ${gradientFrom} ${gradientTo} flex items-center justify-center`}>
          <img src={icon} alt={label} className="w-6 h-6 filter brightness-0 invert" />
        </div>
      )}
      <div className="text-3xl font-bold text-black">{value}</div>
      <div className="text-sm font-medium" style={{ color: '#728F8B' }}>{label}</div>
    </div>
  );
};

export default StatCard;

